"use client"

import { Coffee } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CoffeeIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CoffeeIcon = component(Icon)({ as: Coffee })
